import { SelectProps } from 'antd/lib';

import { TicketPriorityString } from '@/model/Ticket/TicketConstants';

import AntdSelect from './AntdSelect/AntdSelect';
import PriorityLabel from './PriorityLabel';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface PrioritySelectProps extends SelectProps<number> {}

const PrioritySelect = ({ className, ...rest }: PrioritySelectProps) => {
  return (
    <AntdSelect
      {...rest}
      className={`PrioritySelect ${className ?? ''}`.trim()}
      options={Object.values(TicketPriorityString).map((v, index) => ({
        label: v,
        value: index + 1,
      }))}
      labelRender={({ value }) => {
        return <PriorityLabel value={value as number} />;
      }}
      optionRender={({ label, value }) => {
        if (value != undefined) {
          return <PriorityLabel value={value as number} />;
        } else return label;
      }}
      allowClear
    />
  );
};

export default PrioritySelect;
